import {
    Avatar,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
} from '@material-ui/core';
import { formatCpf } from './InputCpf';
import React from 'react';

const Assinante = ({ value: { nome, cpf }, styles }) => (
    <List>
        <ListItem>
            <ListItemAvatar>
                <Avatar color="primary">{nome ? nome[0] : undefined}</Avatar>
            </ListItemAvatar>
            <ListItemText primary={nome} secondary={formatCpf(cpf)} />
        </ListItem>
    </List>
);

Assinante.defaultProps = {
    value: {},
    styles: {
        label: {
            padding: '4px 0px',
        },
        nome: {
            fontSize: '1.2em',
        },
        cpf: {
            fontSize: '0.8em',
        },
    },
};

export default Assinante;
